import { NylasInitiateAuthRequestContent, NylasInitiateAuthResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to initiate OAuth flow to connect a Nylas account
 * @param request Optional provider hint and org context
 * @returns Promise with OAuth authorization URL and state
 */
export const initiateIntegrationAuthApi = async (request: NylasInitiateAuthRequestContent = {}): Promise<NylasInitiateAuthResponseContent> => {
  // The Smithy api-model declares /integrations/nylas/auth/initiate but
  // API Gateway exposes the legacy /oauth/nylas/start handler instead —
  // same response shape ({ authUrl }), different path. Until the Smithy
  // path is registered in the gateway (api-stack.ts), the frontend
  // must call the legacy path or every "Connect Email" click 403s the
  // OPTIONS preflight (resource not found in gateway) and the user
  // sees a "network error" toast.
  const apiRequest = createApiRequest<NylasInitiateAuthResponseContent>('post', '/oauth/nylas/start');
  return apiRequest(request);
};
